import React, { useEffect, useState, useMemo, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ImageLoader(props) {
  // to do: make valuestyle the style of the image
  // make a more tailored model + editor for images
  const {
    value,
    valueStyle
  } = props;
  const [image, setImage] = useState('lazy');
  const ref = useRef();
  const observer = useMemo(() => {
    return new IntersectionObserver(([entry]) => {
      const {
        boundingClientRect: {
          x,
          y
        },
        rootBounds: {
          top,
          bottom,
          left,
          right
        }
      } = entry;
      const isInBounds = bottom > y && y > top && right > x && x > left;
      if (entry.isIntersecting || isInBounds) {
        setImage(value);
      }
    });
  }, [value]);
  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [observer]);

  // if there is no image, render an icon meaning there is no image
  return /*#__PURE__*/_jsx("img", {
    ref: ref,
    src: image,
    alt: value,
    style: valueStyle
  });
}